import { Emitter, Events } from "./events";
import { MockeyEventPlugin } from "./plugin";

const DEFAULT_TRACKING = "G-QYYNXKQZ3D";

export class GoogleAnalytics extends MockeyEventPlugin {
  constructor() {
    super();

    Emitter.on(Events.DOWNLOAD, this.download.bind(this));
    Emitter.on(Events.UPGRADETOPRO, this.upgradeToPro.bind(this));
    Emitter.on(Events.LOGIN, this.login.bind(this));
    Emitter.on(Events.TRACK_BUTTON_CLICK, this.trackButtonClick.bind(this));
    Emitter.on(Events.AI_BG_GENERATOR, this.aiBgGeneration.bind(this));
    Emitter.on(Events.SEARCH, this.search.bind(this));
    Emitter.on(Events.NAVBAR_3D_ClICK, this.navbar3DClicked.bind(this));
    Emitter.on(Events.DOWNLOAD_3D, this.download3D.bind(this));
    Emitter.on(Events.SELECT_ASPECT_RATIO, this.selectAspectRatio.bind(this));
    Emitter.on(
      Events.DOWNLOAD_VIDEO_3D_CLICK,
      this.downloadVideo3dClicked.bind(this),
    );
    Emitter.on(
      Events.DOWNLOAD_WALKING_ANIMATION,
      this.downloadWalkingAnimation.bind(this),
    );
    Emitter.on(
      Events.SELECT_SIDEBAR_OPTION,
      this.selectSidebarOption.bind(this),
    );
    Emitter.on(Events.IMAGE_UPLOADED, this.imageUploadedCM.bind(this));
    Emitter.on(Events.DESIGN_UPLOADED, this.designUploadedCM.bind(this));
    Emitter.on(Events.CUSTOM_MOCKUP_DOWNLOAD, this.downloadCM.bind(this));
    Emitter.on(
      Events.DESIGN_UPLOAD_VIDEO_MOCKUP,
      this.designUploadVM.bind(this),
    );
    Emitter.on(
      Events.CLICK_GENERATE_VIDEO_MOCKUP,
      this.clickGenerateVM.bind(this),
    );

    this.loadGoogleAnalytics();
    this.configureTracker();
  }

  loadGoogleAnalytics() {
    if (!window.dataLayer) {
      const script = document.createElement("script");
      script.async = true;
      script.setAttribute(
        "src",
        `https://www.googletagmanager.com/gtag/js?id=${DEFAULT_TRACKING}`,
      );
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      this.gtag("js", new Date());
      this.gtag("config", DEFAULT_TRACKING);
    }
  }

  async configureTracker() {
    let gaTrackCode = DEFAULT_TRACKING;
    if (gaTrackCode && gaTrackCode.length > 5) {
      this.gtag("config", gaTrackCode);
    }
  }

  gtag(...args) {
    if (!window.gtag)
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    window.gtag(...args);
  }

  download(data) {
    this.gtag("event", "download", {
      name: data.name,
      category: data.category,
      subcategory: data.subcategory,
      user: data.user,
      size: data.size,
      user_type: data.user_type,
      format: data.format,
    });
  }

  upgradeToPro(data) {
    this.gtag("event", "upgradeToPro", {
      isLoggedIn: data.isLoggedIn,
      plan: data.plan,
    });
  }

  login(data) {
    this.gtag("event", "login", {
      LoginType: data.LoginType,
      page: data.page,
    });
  }

  trackButtonClick(data) {
    this.gtag("event", "click", {
      name: data.name,
    });
  }

  aiBgGeneration(data) {
    this.gtag("event", "aiBgGeneration", {
      user: data.user,
      userType: data.userType,
      mockupUrl: data.url,
      prompt: data.prompt,
      generations: data.urls,
    });
  }

  search(data) {
    this.gtag("event", "search", {
      userInput: data.userInput,
      suggestionClicked: data.suggestion,
    });
  }

  navbar3DClicked(data) {
    this.gtag("event", "3DMockupClicked", {
      click: data.click,
    });
  }

  download3D(data) {
    this.gtag("event", "download3D", {
      name: data.name,
      size: data.size,
      format: data.format,
    });
  }

  selectAspectRatio(data) {
    this.gtag("event", "selectAspectRatio", {
      name: data.name,
      aspectRatio: data.aspectRatio,
    });
  }

  downloadVideo3dClicked(data) {
    this.gtag("event", "downloadVideo3dClicked", {
      click: data.click,
    });
  }

  downloadWalkingAnimation(data) {
    this.gtag("event", "downloadWalkingAnimation", {
      name: data.name,
      user: data.user,
      user_type: data.user_type,
    });
  }

  selectSidebarOption(data) {
    this.gtag("event", "selectSidebarOption", {
      name: data.name,
      option: data.option,
    });
  }

  imageUploadedCM(data) {
    this.gtag("event", "imageUploadedCustomMockup", {
      name: data.name,
      user: data.user,
      size: data.size,
      user_type: data.user_type,
    });
  }

  designUploadedCM(data) {
    this.gtag("event", "designUploadedCustomMockup", {
      name: data.name,
      user: data.user,
      user_type: data.user_type,
    });
  }

  downloadCM(data) {
    this.gtag("event", "downloadCustomMockup", {
      name: data.name,
      user: data.user,
      size: data.size,
      user_type: data.user_type,
      format: data.format,
    });
  }

  designUploadVM(data) {
    this.gtag("event", "designUploadVideoMockup", {
      name: data.name,
    });
  }

  clickGenerateVM(data) {
    this.gtag("event", "clickGenerateVideoMockup", {
      name: data.name,
      user: data.user,
    });
  }
}
